import { FiltersStoreService } from './services/store/filters-store/filters-store.service';
import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { LevelOfServiceService } from '../component/level-of-service/service/level-of-service.service';
import { forkJoin } from 'rxjs';
import * as _ from 'underscore';
import { sweetAlert } from '../utils/swal';
import { CorporateService } from '../component/corporate-user/corporate-service/corporate-service';
import { ServiceAreasService } from '../component/service-areas/service-areas-service/service-areas.service';
import { MemberService } from '../component/members/member-service/member.service';
import { DriversService } from '../component/drivers/drivers-service/drivers-service';
import { takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { SharedDataService } from '../service/shared-service/shared-data.service';
import { FundingsourcestoreService } from './services/store/fundingsource-store/fundingsource-store.service';
import { SpaceTypeStoreService } from './services/store/spacetype-store/spacetype-store.service';
import { LosStoreService } from './services/store/los-store/los-store.service';
import { DriversStoreService } from './services/store/drivers-store/drivers-store.service';
import { ServiceareaStoreService } from './services/store/servicearea-store/servicearea-store.service';
import { AssigTripsService } from '../component/assigned-trips/assigntrips-service/assigntrips-service';
import { TripStoreService } from './services/store/trip-store/trip-store.service';
import { FleetService } from '../component/fleet/fleet-service/fleet.service';
import { FleetStoreService } from './services/store/fleet-store/fleet-store.service';
import { AgmMap } from '@agm/core';
import * as moment from 'moment-timezone';
import { DetailStoreService } from './services/store/detail-store/detail-store.service';
import { SearchStoreService } from './services/store/search-store/search-store.service';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css']
})
export class MainComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild("AgmMap", { static: false }) agmElement: AgmMap;
  latitude = 35.125801;
  longitude = -117.9859038;
  initialZoom = 12;
  selectedTab = 'Timeline'
  user: any;
  trips: any = [];
  filterTripsList = [];
  spaceTypeList = [];
  levelOfServiceList = [];
  preLevelOfServices: any = {};
  preSpaceTypes: any = {};
  skip = 0;
  currentDate;
  agmMap;
  selectedSpaceType;
  selectedStatus = [];
  timeZone;
  mapTrips = [];


  constructor(
    private sharedDataService: SharedDataService,
    private driverService: DriversService,
    private fleetService: FleetService,
    private serviceArea: ServiceAreasService,
    private corporateService: CorporateService,
    private los: LevelOfServiceService,
    private fundingSourceStore: FundingsourcestoreService,
    private spaceTypeStore: SpaceTypeStoreService,
    private serviceAreasStore: ServiceareaStoreService,
    private losStore: LosStoreService,
    private driverStore: DriversStoreService,
    private fleetStore: FleetStoreService,
    private assignTripService: AssigTripsService,
    private filtersStoreService: FiltersStoreService,
    private tripStore: TripStoreService,
    private detailStore: DetailStoreService,
    private searchStore: SearchStoreService
  ) { }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.agmElement.mapReady
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((map) => {
        this.agmMap = map;
        this.getUser();
      });
  }

  onSearch(data) {
    console.log(data);

    if (data) {
      this.currentDate = data.date;
      this.skip = 0;
      this.trips = [];
      this.filterTripsList = [];
      this.tripStore.setEntities([]);
      this.filtersStoreService.setEntities([], []);
      this.detailStore.setEntities([]);

      const payload: any = {
        isShowAllTrips: false,
        status: 'all',
        showBreak: true,
        skip: this.skip,
        scheduleTime: data.date.toString(),
      };

      if (data.cooperates && data.cooperates.length) {
        payload.cooperates = data.cooperates.toString();
      }
      if (data.serviceAreas && data.serviceAreas.length) {
        payload.serviceAreas = data.serviceAreas.toString();
      }
      if (data.spaceTypes && data.spaceTypes.length) {
        payload.spaceTypes = data.spaceTypes.toString();
      }
      if (data.reference) {
        payload.tripId = data.reference;
      }

      this.getTrips(payload);
    }

  }


  getTrips(payload?: any) {
    this.assignTripService.getTripListNew(payload).pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          this.trips = [...data, ...this.trips];
          if (data.length) {
            this.skip += data.length;
            this.getTrips({ ...payload, skip: this.skip });

          } else {
            this.prepareData();
          }

        }, err => {
          sweetAlert('Error', err, 'warning', 'OK');
        });
  }

  prepareData() {
    this.filterTripsList = this.trips;
    this.tripStore.setEntities(this.filterTripsList);
    let services = [];

    const statuses = [

        // ['marketplaced','pending', 'offered', 'accepted',
        //
        //  'onway',
        //  'arrived',
        //  'started',
        //  'completed',
        //  'cancelled',
      //  'finished'];

      { name: "WillCall", value: ["willcall"], selected: true },
      { name: "Pending", value: ['marketplaced','pending', 'offered', 'accepted'], selected: true },
      { name: "Onway", value: ["onway"], selected: true },
      { name: "Arrived", value: ["arrived"], selected: true },
      { name: "In Vehicle", value: ["started"], selected: true },
      { name: "Exiting", value: ["completed"], selected: true },
      { name: "Canceled", value: ["cancelled"], selected: true },
      { name: "Rode", value: ["finished"], selected: true },
    ];

    for (let item of this.trips) {
      if (this.preLevelOfServices && this.preLevelOfServices[item.los]) {
        services.push({ ...this.preLevelOfServices[item.los], selected: true });
      }
    }
    services = _.uniq(services, '_id').sort();

    this.filtersStoreService.setEntities(services, statuses)
    this.filterTrips();
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(user => {
        if (user) {
          this.user = user
          this.timeZone = user.company ? user.company.timeZone : user.timeZone;
          this.latitude = user.latitude;
          this.longitude = user.longitude;
          this.skip = 0;
          this.trips = [];
          this.filterTripsList = [];
          this.tripStore.setEntities([]);
          this.filtersStoreService.setEntities([], []);
          this.makeCompulsoryCalls();
        }
      });
  }

  makeCompulsoryCalls() {


        this.spaceTypeStore.state$.subscribe((res) => {
      if (res) {
        this.spaceTypeList = res.list
        this.preSpaceTypes = res.map;
      }
    })

    this.losStore.state$.subscribe((res) => {
      if (res) {
        this.levelOfServiceList = res.list;
        this.preLevelOfServices = res.map;
      }
    })

    this.detailStore.state$.subscribe((data: any) => {
      this.mapTrips = data.list;
      this.setBounds(this.mapTrips);

    })

    this.filtersStoreService.state$.subscribe((res) => {
      if (res) {
        this.selectedStatus = res.statuses;
        this.selectedSpaceType = res.services;
        this.filterTrips();
      }
    })

    this.searchStore.state$.subscribe((res: any) => {
      if (res) {
        this.onSearch(res);
      }
    })

    const requests = [
      this.corporateService.getCorporateUsers('active'),
      this.los.getLevelOfServices({ status: 'active' }),
      this.los.getSpaceTypes({ status: 'active' }),
      this.serviceArea.getServiceAreas({ status: 'active' }),
      this.driverService.getDrivers(this.user._id, "active"),
      this.fleetService.getFleetList({ 'isFleetSection': true, 'status': 'active' })
    ];

    // Make all requests in parallel
    forkJoin(requests).subscribe(
      ([res1, res2, res3, res4, res5, res6]) => {
        if (res1) {
          this.fundingSourceStore.setEntities(res1);
        }
        if (res2) {
          this.losStore.setEntities(res2);
        }
        if (res3) {
          this.spaceTypeStore.setEntities(res3);
        }

        if (res4) {
          this.serviceAreasStore.setEntities(res4);
        }
        if (res5) {
          this.driverStore.setEntities(res5);
        }
        if (res6) {
          this.fleetStore.setEntities(res6);
        }
;
      },
      error => {
        sweetAlert('Error', error, 'error', 'OK');
      }
    );
  }

  filterTrips() {
    console.log(this.selectedStatus)
    const selectedStatuses = this.selectedStatus
      .filter(status => status.selected)
      .reduce((acc, curr) => acc.concat(curr.value), []);

    const hasStatusFilter = selectedStatuses.length > 0;

    const willCallTime = moment().tz(this.timeZone).hour(22).minute(0).second(0).millisecond(0);

    this.filterTripsList = this.trips.filter(trip => {

      const matchesStatus =
        !hasStatusFilter ||
        (selectedStatuses.includes(trip.jobStatus));
        // ||
        // (selectedStatuses.includes('willcall') &&
        //   moment(trip.scheduleTime).tz(this.timeZone).isSameOrAfter(willCallTime));

        const selectedSpaceTypeIds = (this.selectedSpaceType || []).filter(status => status.selected).map(item => item._id);
        const hasSpaceTypeFilter = selectedSpaceTypeIds.length > 0;

      let matchesSpaceType =
        !hasSpaceTypeFilter || selectedSpaceTypeIds.includes(trip.los);

      if (matchesStatus && trip.isBreakTrip) matchesSpaceType = true;

      // if (!(matchesStatus && matchesSpaceType)) {
      //   console.log("los: ", trip.los);
      //   console.log((matchesStatus && matchesSpaceType) + trip.tripId + ' - ' + trip.status + ' - ' + trip.jobStatus + ' -matchesStatus:' + matchesStatus, ' -matchesSpaceType:' + matchesSpaceType)
      // }

      let isCompatible = (matchesStatus && matchesSpaceType);

      console.log({matchesStatus, matchesSpaceType})

      if (isCompatible && !selectedStatuses.includes('willcall')) {
        console.log(trip.jobStatus)
        console.log("bf will call", isCompatible)
         const orignalTime = moment(trip.scheduleTime).tz(this.timeZone);
        isCompatible = !moment(orignalTime.format('HH:mm:ss'), 'HH:mm:ss').tz(this.timeZone).isSameOrAfter(willCallTime);
        console.log("after will call",isCompatible )
      }

      return isCompatible;
    });

    console.log(this.filterTripsList);

    this.tripStore.setEntities(this.filterTripsList);
    this.detailStore.setEntities([]);

  }


  setBounds(trips) {
    if (this.agmMap && trips && trips.length) {
      const bounds = new google.maps.LatLngBounds();
      for (const trip of trips) {
        bounds.extend(
          new window["google"].maps.LatLng(
            trip.jobOriginLatitude,
            trip.jobOriginLongitude
          )
        );
      }
      this.agmMap.fitBounds(bounds);
      this.agmMap.setCenter(bounds.getCenter());
    }
  }


  onUpdateTrip(trip: any) {
    const indexTwo = this.trips.findIndex((item) => item._id === trip._id);
    if (indexTwo !== -1) {
      this.trips[indexTwo] = trip;
    }
  }

  quickFilter(data) {
    console.log("Data check",data);
    this.currentDate = data.date;
    this.skip = 0;
    this.trips = [];
    this.filterTripsList = [];
    this.tripStore.setEntities([]);
    this.filtersStoreService.setEntities([], []);
    this.detailStore.setEntities([]);

    const payload: any = {
      isShowAllTrips: false,
      status: 'all',
      skip: this.skip,
      ...data

    };
    this.getTrips(payload);

  }

  ngOnDestroy(): void {

  }

  trackByFn(index: number, item: any): number {
    return index;
  }

}
